import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from '@marvelapp/styled';
import { AspectRatio, Image } from '@marvelapp/ui';
import TransparentBorder from './TransparentBorder';
import { ImageIcon } from './icons';
import transparency from './images/transparency.svg';
export default function AssetPreview(_a) {
    var url = _a.url;
    return (React.createElement(AspectRatio, { ratio: 1 / 1 },
        React.createElement(Preview, null, url ? (React.createElement(Image, { height: "100%", maxHeight: "80%", maxWidth: "80%", objectFit: "contain", src: url, src2x: url, width: "100%" })) : (React.createElement(ImageIcon, { color: "slate", width: 24 }))),
        React.createElement(TransparentBorder, null)));
}
var Preview = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  background-image: url(", ");\n  background-position: top left;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n"], ["\n  width: 100%;\n  height: 100%;\n  background-image: url(", ");\n  background-position: top left;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n"])), transparency);
var templateObject_1;
